import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    setLayerSelectedLayerFromSearch
} from '../../../../redux/layers/Actions';
import {
    setSearchedLayer
} from '../../../../redux/panel/search_panel/Actions';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import {
    Typography,
    TextField,
    InputAdornment, Menu, Popover, Popper, ClickAwayListener
} from '@material-ui/core';
import ScrollableContainer from '../../../utility/ScrollableContainer';
import SearchIcon from '@material-ui/icons/Search';
import withStyles from '@material-ui/core/styles/withStyles';

const LayerSearchTextField = withStyles((theme) => ({
    root: {
        '& .MuiInputBase-root': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.background.border
            },
            '& .MuiInputBase-input': {
                padding: '15px 0px'
            }
        }
    }
}))(TextField);

class SearchLayers extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            filter: '',
            filteredLayersHTML: [],
            anchorEl: null,
            placement: null
        };
        this.root = React.createRef();
    }

    createLayerList (filter) {
        const {
            layers,
            classes,
            dispatchSetSearchedLayer
        } = this.props;
        const filteredLayers = layers.filter(layer => {
            const matches = match(layer.name, filter);
            // console.log(layer.name)
            return matches.length > 0;
        });

        const categories = [...new Set(filteredLayers.map(layer => layer.category ? layer.category : 'Others'))];

        const html = categories.map((category, i) => {
            return (
                <div key={i} className={classes.layerListItem}>
                    <div className={classes.layerListTitle}>
                        <Typography
                            variant="body1"
                            color="textPrimary"
                        >
                            •&nbsp;{ category }
                        </Typography>
                    </div>
                    <div className={classes.layerListLayers}>
                        { filteredLayers.map((layer, j) => {
                            if (layer.category === category) {
                                const matches = match(layer.name, filter);
                                const parts = parse(layer.name, matches);

                                return (
                                    <Typography
                                        variant="body2"
                                        color="textPrimary"
                                        key={j}
                                        className={classes.layerListLayersItem}
                                        onClick={(e) => {
                                            dispatchSetSearchedLayer({ category: layer.category, systemName: layer.system_name });
                                            this.setState({
                                                filteredLayersHTML: this.createLayerList(e.target.value)
                                            });
                                        }}
                                    >
                                        { parts.map((part, k) => {
                                            return part.highlight ? (
                                                <span className={classes.highlightedText} key={k}>{part.text}</span>
                                            ) : (
                                                <span key={k}>{part.text}</span>
                                            );
                                        }) }
                                    </Typography>
                                );
                            }
                        }) }
                    </div>
                </div>
            );
        });

        return html;
    }

    onPopperUpdate = (e) => {
        if (e.placement !== this.state.placement) {
            this.setState({
                placement: e.placement
            });
        }
    };

    render () {
        const { classes } = this.props;
        const { filteredLayersHTML, filter, placement, anchorEl } = this.state;
        return (
            <>
                <TextField
                    ref={this.root}
                    classes={{ root: classes.textFieldRoot }}
                    placeholder="Search layer library"
                    variant="outlined"
                    type="text"
                    fullWidth
                    value={filter}
                    onChange={(e) => {
                        this.setState({
                            filter: e.target.value,
                            filteredLayersHTML: this.createLayerList(e.target.value),
                            anchorEl: this.root.current
                        });
                    }}
                    InputProps={{
                        classes: {
                            root: Boolean(anchorEl) && (placement === 'top' ? classes.popperBottom : classes.popperTop)
                        },
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        )
                    }}
                />
                { filteredLayersHTML.length > 0 && filter !== '' ? (
                    <ClickAwayListener onClickAway={() => { this.setState({ anchorEl: null }); }}>
                        <Popper
                            className={classnames(classes.popper, placement === 'top' ? classes.popperTop : classes.popperBottom)}
                            style={{ width: this.root.current.offsetWidth }}
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            popperOptions={{
                                onUpdate: this.onPopperUpdate
                            }}
                        >
                            <ScrollableContainer>
                                { filteredLayersHTML }
                            </ScrollableContainer>
                        </Popper>
                    </ClickAwayListener>
                ) : '' }
            </>
        );
    }
}

const style = theme => ({
    textFieldRoot: {
        '& .MuiInputBase-root': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.background.border
            },
            '& .MuiInputBase-input': {
                padding: '15px 0px'
            }
        }
    },
    popper: {
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 400,
        overflow: 'hidden',
        border: `1px solid ${theme.palette.background.border}`,
        backgroundColor: theme.palette.grey.variant2,
        boxSizing: 'border-box'
    },
    popperTop: {
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    popperBottom: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5
    },
    layerListItem: {
        padding: '10px',
        '&:not(:last-child)': {
            borderBottom: `1px dashed ${theme.palette.background.border}`
        }
    },
    layerListTitle: {
        paddingBottom: '10px'
    },
    layerListLayers: {

    },
    layerListLayersItem: {
        paddingBottom: '5px',
        paddingTop: '5px',
        paddingLeft: '20px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.grey.variant3
        }

    },
    highlightedText: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.primary
    }
});

const mapStateToProps = state => {
    return {
        layers: state.layers.layers.filter(el => el.display),
        searchPanel: state.search_panel
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSetLayerSelectedLayerFromSearch: ({ category, systemName }) => dispatch(setLayerSelectedLayerFromSearch({ category, systemName })),
        dispatchSetSearchedLayer: ({ category, systemName }) => dispatch(setSearchedLayer({ category, systemName }))

    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(SearchLayers);